export default class ComponentPerguntasFrequentes {
    constructor() {

        this.section = document.querySelector('.component-perguntas_frequentes')

        this.categorias = this.section.querySelectorAll('nav ul li')
        this.categoriasPerguntas = this.section.querySelectorAll('.categoria-perguntas')
        this.perguntas = this.section.querySelectorAll('.pergunta')

        this.ready();
    }

    ready() {

        this.categorias.forEach((e) => {
            e.addEventListener('click', (event) => {
                const categoria = e.dataset.categoria

                this.categorias.forEach(menu => {
                    menu.classList.remove('active')
                })

                this.categoriasPerguntas.forEach(list => {
                    list.classList.remove('active')
                })

                e.classList.add('active')
                document.querySelector('#cat-'+categoria).classList.add('active')

            })
        })

        this.perguntas.forEach(pergunta => {
            pergunta.addEventListener('click', () => {
                pergunta.classList.toggle('active')
            })
        })

    }
}